export default [
  {
    path: '/:locale([en/]*)?/music',
    name: 'Music',
    component: () => import('@/views/music/Index'),
    meta: {
      sitemap: {
        loc: '/music'
      }
    }
  },
  {
    path: '/:locale([en/]*)?/music/license',
    name: 'MusicLicense',
    component: () => import('@/views/music/License'),
    meta: {
      language: false,
      parent: 'Music',
      sitemap: {
        loc: '/music/license'
      }
    }
  }
]
